import { Theme } from '@mui/material';

export const sectionBoxProps = () =>
{
  return({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    pt: 6,
    pb: 6,
    //px: { xs: 2, md: 4, lg: 4 }
  });
};

export const sectionHeadingBoxProps = (theme: Theme) =>
{
  return({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 1180,
    mt: '3rem',
    mb: 2,
    justifyContent: 'center',
    [theme.breakpoints.down('md')]:
    {
      mt: '2rem',
      maxWidth: '100%'
    }
  });
};

export const subsectionBoxProps = (theme: Theme) =>
{
  return({
    [theme.breakpoints.down('md')]:
    {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }
  });
};

export const subSectionHeadingBoxProps = (theme: Theme) =>
{
  return({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    maxWidth: 1260,
    height: { xs: 'auto', md: 'auto' },
    gap: '40px',
    alignItems: 'center',
    mt: 8,
    mb: 4,
    [theme.breakpoints.down('md')]:
    {
      flexDirection: 'column',
      mt: 0,
      mb: 0,
      gap: '5px'
    }
  });
};

export const subSectionImageBoxProps = () =>
{
  return({
    width: '100%',
    height: { xs: 'auto', md: 'auto', lg: 'auto' },
    objectFit: 'cover',                    
    borderRadius: '12px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    transition: 'background-image 1s ease-in-out',
    border: ' 1px solid #7A7A7A',
  });
};

export const subSectionContentBoxProps = () =>
{
  return({
    flex: 1,
    display: { xs: 'none', md: 'flex' },                 
    flexDirection: 'column',
    textAlign: { xs: 'center', md: 'left' },
    alignItems: { xs: 'center', md: 'flex-start' },
    maxWidth: { xs: '100%', lg: 325 },
    mt: { xs: 0, lg: 0 },
    px: { xs: 1, sm: 2, md: 3, lg: 0 }
  });
};

export const sectionHeadingProps = () =>
{
  return({
    fontWeight: 700,
    textAlign: 'center',
    color: '#ffffffff',
    fontSize: { xs: '24px', sm: '32px', md: '40px' },
    whiteSpace: { xs: 'nowrap', sm: 'normal' },
    mb: { xs: '16px', sm: 2, md: '24px' },
  });
};

export const sectionSubHeadingProps = () =>
{
  return({
    fontWeight: 400,
    textAlign: 'center',            
    color: '#ffff',
    fontSize: { xs: '16px', sm: '20px', md: '28px' },
    mb: { xs: '24px' },
  });
};

export const subSectionHeadingProps = (theme: Theme) =>
{
  return({
    fontWeight: 500,
    lineHeight: '110%',
    color: '#C0C0C0',
    fontSize: { xs: '16px', md: '16px', lg: '29px' },
    [theme.breakpoints.down('md')]:
    {
      textAlign: 'center',
      lineHeight: '120%',
      color: '#FFFFFF'
    }
  });
};

export const subSectionHeadingPropsMobile = () =>
{
  return({
    fontWeight: 600,  
    lineHeight: '25px',
    textAlign: 'center',                      
    color: '#ffffff',
    maxWidth:'80%',
    fontSize: '20px',
    display: { xs: 'block', md: 'none' },
    mt: '20px',
    mb: 1.6,
  });
};

export const subSectionDescriptionProps = () =>
{
  return({
    fontWeight: 300,
    lineHeight: '25px',
    fontSize: '16.8px',
    color: '#C0C0C0',
    mt: 2,
    mb: 4
  });
};

export const subSectionDescriptionPropsMobile = () =>
{
  return({
    fontWeight: 300,
    lineHeight: '122%',
    fontSize: '14px',
    color: '#C0C0C0',
    textAlign: 'center',
    width:"355px",
    display: { xs: 'block', md: 'none' },
    mt: 2,
  });
};

export const footerBoxProps = (theme: Theme) =>
{
  return({
    mt: 6,
    [theme.breakpoints.down('md')]:
    {
      mt: 6
    }
  });
};